import { __assign } from "tslib";
import { VangoghMode, ResizeAPI, ResizeMode } from './types';
import { normalizeUrl } from './utils/normalize-url';
var isFromShutterstock = function (url) { return /shutterstock/i.test(url); };
var isResizable = function (url) { return /\.(png|jpe?g?|gif|webp)/i.test(url) && !isFromShutterstock(url); };
var getFullName = function (url) { return url.split('/').pop() || ''; };
var getFolderUrl = function (url) {
    var path = url.split('/');
    if (path.length <= 1) {
        return '';
    }
    path.pop();
    return path.join('/') + "/";
};
var transformModeToVangogh = function (mode) {
    return VangoghMode[mode] || mode;
};
var createRegexp = function (str, options) { return new RegExp(str.replace(/[()[\].^$|?+]/g, '\\$&'), options); };
var insertDataInTemplate = function (template, data) {
    Object.keys(data).forEach(function (key) {
        var regExp = createRegexp("#" + key + "#", 'g');
        template = template.replace(regExp, data[key]);
    });
    return template;
};
var compilers = {
    // //some.server.com/folder/123.jpg >>
    // //some.server.com/folder/123.jpg_srz_100_200_75_22_0.5_1.20_0.00_jpg_srz
    vangogh: function (sourceUrl) {
        return getFolderUrl(sourceUrl) + getFullName(sourceUrl) + "_#mode#_#width#_#height#_75_22_0.5_1.20_0.00_jpg_#mode#";
    },
    // //some.server.com/folder/123/file.jpg >>
    // //some.server.com/folder/123/v1/fill/w_100,h_200/file.jpg'
    // //some.server.com/folder/123/123.jpg >>
    // //some.server.com/folder/123/v1/fill/w_100,h_200/123.jpg'
    rembrandt: function (sourceUrl, waterMark) {
        var fullName = getFullName(sourceUrl);
        var url = getFolderUrl(sourceUrl) + "v1/#mode#/w_#width#,h_#height#";
        return waterMark ? url + ",wm_#waterMark#/" + fullName : url + "/" + fullName;
    },
    // //some.server.com/folder/123.jpg >>
    // //some.server.com/folder/123.jpg/v1/fill/w_100,h_200/123.jpg
    vanbrandt: function (sourceUrl, waterMark) {
        var fullName = getFullName(sourceUrl);
        var url = getFolderUrl(sourceUrl) + fullName + "/v1/#mode#/w_#width#,h_#height#";
        return waterMark ? url + ",wm_#waterMark#/#fileName#" : url + "/#fileName#";
    },
};
var REGEXPS = {
    VANGOGH: /_sr[bz]_(?:[0-9.]+_)+[a-z0-9]+_sr[bz]$/i,
    VANBRANDT: /([a-z0-9_-~]+\.[a-z0-9]+)\/v[0-9]+\/(?:fill|fit)\/[^/]+\/(?:\1|file\.[a-z0-9_]+)$/i,
    REMBRANDT: /([a-z0-9_-]+)\/v[0-9]+\/(?:fill|fit)\/[^/]+(\/(?:\1|file)\.[a-z0-9_]+)$/i,
};
var restoreUrlIfResized = function (sourceUrl) {
    var waterMark = (sourceUrl.match(/wm_([^/]*)/) || [])[1];
    return {
        restoredUrl: sourceUrl
            .replace(REGEXPS.VANGOGH, '')
            .replace(REGEXPS.VANBRANDT, '$1')
            .replace(REGEXPS.REMBRANDT, '$1$2'),
        waterMark: waterMark,
    };
};
/**
 * Resize image
 * @param sourceUrl {string}
 * @param settings {object}
 * @param settings.width {number} default 200
 * @param settings.height {number} default 200
 * @param settings.mode {string} from this.MODES, default 'fill'
 * @param settings.waterMark {string | undefined}'
 * @param apiName {string} from this.APIS, default 'rembrandt'
 * @return {string|undefined} URL for resized image or undefined if can`t resize
 */
export var resize = function (sourceUrl, settings, apiName) {
    if (settings === void 0) { settings = {}; }
    if (apiName === void 0) { apiName = ResizeAPI.Vanbrandt; }
    var _a = restoreUrlIfResized(sourceUrl), restoredUrl = _a.restoredUrl, restoredWatermark = _a.waterMark;
    if (!isResizable(restoredUrl)) {
        return restoredUrl;
    }
    var _b = settings.width, width = _b === void 0 ? 200 : _b, _c = settings.height, height = _c === void 0 ? 200 : _c, _d = settings.mode, mode = _d === void 0 ? ResizeMode.Fill : _d, _e = settings.fileName, fileName = _e === void 0 ? getFullName(restoredUrl) : _e, _f = settings.waterMark, waterMark = _f === void 0 ? restoredWatermark : _f;
    var resizeSettings = __assign(__assign({}, settings), { fileName: fileName,
        waterMark: waterMark,
        width: width,
        height: height,
        mode: mode });
    if (apiName === ResizeAPI.Vangogh) {
        resizeSettings.mode = transformModeToVangogh(resizeSettings.mode);
    }
    var templateUrl = compilers[apiName](restoredUrl, waterMark);
    var compiledUrl = insertDataInTemplate(templateUrl, resizeSettings);
    return normalizeUrl(compiledUrl);
};
//# sourceMappingURL=resize.js.map